import { useSelectedSystem } from 'projectSections/designPanels/hooks/useSelectedSystem'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ComponentDependencies } from 'types/associatedComponents'
import { RootState } from 'types/state'

const NonModuleComponentTypesLookup = {
  others: 'other',
  batteries: 'battery',
  inverters: 'inverter',
}

const useRecommendedAndRequiredComponentOrdering = (): string[] => {
  const system = useSelectedSystem()
  const selectedTab = useSelector((state: RootState) => state.designer.view.selectedTab)

  const componentDependencies = system?.custom_data?.['component_dependencies']

  return useMemo(() => {
    const nonModuleComponentType = NonModuleComponentTypesLookup[selectedTab as string]
    const recommendedAndRequiredComponents: Record<string, string> = {}
    if (nonModuleComponentType) {
      const dependencies: ComponentDependencies = componentDependencies || []

      dependencies.forEach((dependency) => {
        const requiredComponents = dependency?.require || []
        const recommendedComponents = dependency?.recommend || []
        const components = [...requiredComponents, ...recommendedComponents]
        components?.forEach((component) => {
          const componentCode = component.code
          if (nonModuleComponentType && [nonModuleComponentType].includes(component.componentType)) {
            if (!component.totalCalculatedQty || recommendedAndRequiredComponents[componentCode]) return
            recommendedAndRequiredComponents[componentCode] = componentCode
          }
        })
      })
    }

    // Stable order → stable JSON.stringify(order_by_codes) in hardware list filters across re-renders.
    return Object.keys(recommendedAndRequiredComponents).sort()
  }, [componentDependencies, selectedTab])
}

export default useRecommendedAndRequiredComponentOrdering
